import React from 'react';
import {BaseTextProps, textSizes} from './types';
import {useTheme} from 'styled-components';

interface Props extends BaseTextProps {
  children?: React.ReactNode;
  fontWeight?: string;
  fontFamily?: string;
  style?: React.CSSProperties;
  numberOfLines?: number;
}

const BaseText: React.FC<Props> = ({
  children,
  fontWeight,
  fontFamily,
  size,
  color,
  textAlign,
  style = {},
  ...props
}) => {
  const {colors} = useTheme();

  return (
    <text
      {...props}
      style={{
        fontSize: textSizes[size ?? 'regular'] * 1.1,
        color: colors[color ?? 'text'] as string,
        textAlign: textAlign ?? 'left',
        fontWeight,
        fontFamily,
        ...style,
      }}>
      {children}
    </text>
  );
};

const LightText: React.FC<Props> = (props) => {
  return (
    <BaseText {...{...props, fontWeight: '300', fontFamily: 'Montserrat'}} />
  );
};

const RegularText: React.FC<Props> = (props) => {
  return <BaseText {...{...props, fontFamily: 'Montserrat'}} />;
};

const MediumText: React.FC<Props> = (props) => {
  return (
    <BaseText {...{...props, fontWeight: '500', fontFamily: 'Montserrat'}} />
  );
};

const SemiBoldText: React.FC<Props> = (props) => {
  return (
    <BaseText {...{...props, fontWeight: '600', fontFamily: 'Montserrat'}} />
  );
};

const BoldText: React.FC<Props> = (props) => {
  return (
    <BaseText {...{...props, fontWeight: '600', fontFamily: 'Montserrat'}} />
  );
};

export {BoldText, LightText, MediumText, RegularText, SemiBoldText};
